<template>
    <div class="mb-4">
        <template v-for="(item, idx) of states.items" :key="idx">
            <UltimateServiceItem :item="item" />
        </template>
    </div>
</template>

<script>
import ConfigManager from "@/config/ConfigManager"
import useDashboardComposable from "@/composables/Dashboard/DashboardComposable"
import UltimateServiceItem from '@/module/UltimateService/component/UltimateServiceItem.vue'
export default {
    name: 'Ultimateservicelist',
    components:{
        UltimateServiceItem
    },
    props: {
        modalController: { type: Object }
    },
    setup: function (props, { emit }) {
        return useDashboardComposable(ConfigManager.getDashboardUltimateService(), emit)
    },
};
</script>

<style lang="scss" scoped>

</style>
